import React from "react";

import { Amenity } from "../../../definitions/property";
import Flex from "../../structure/Flex";
import Icon from "../Icon";

interface AmenitiesProps {
  list: Amenity[];
  amenityClassname?: string;
  iconOnly?: boolean;
}

const Amenities: React.FC<AmenitiesProps> = ({
  list,
  amenityClassname,
  iconOnly,
}) => {
  return (
    <Flex items="center" className="flex-wrap max-w-full">
      {list.map((l) => (
        <Flex
          key={l.id}
          items="center"
          className={`${amenityClassname} flex-shrink-0 relative group`}
        >
          <Icon className={`flex-shrink-0 ${iconOnly ? "" : "mr-1"}`}>
            {l.code}
          </Icon>
          <span
            className={`font-medium text-sm text-text ${
              iconOnly
                ? "absolute bottom-full pointer-events-none bg-text text-light p-2 leading-none opacity-0 group-hover:opacity-100 m-1 rounded-lg whitespace-no-wrap shadow-xl"
                : ""
            }`}
          >
            {l.name}
          </span>
        </Flex>
      ))}
    </Flex>
  );
};

export default Amenities;
